import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape } from "@ai360/core/intl";

import { Button, DialogBox, DataTable } from "~/core";

import { service, actions } from "./data";
import { withMasked, withApiResult, withCrud } from "~/hocs";
import SlidingPanel from "~/sliding-panel/sliding-panel";
import { preventBubbleUp } from "~/admin/utils";
import AddEditPanel from "./add-edit/add-edit-container";
import { ImportExportHeader } from "../../agBytes/components/import-export-header";
import { messages } from "../../agBytes/i18n-messages";
import { NutrientTargetValueLog } from "./nutrient-target-value-log";

export class NutrientTargetValue_ extends Component {
    static propTypes = {
        actions: PropTypes.object,
        addEditPanel: PropTypes.object,
        closeSidePanel: PropTypes.func,
        deleteSelected: PropTypes.func,
        intl: intlShape.isRequired,
        needs: PropTypes.func,
        onSubmit: PropTypes.func,
        toggleActiveInactive: PropTypes.func,
    };
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
        };
        this.tableFooterOptions = [
            {
                label: "Delete Selected",
                action: this.props.deleteSelected,
            },
        ];
    }
    onToggleModalClick = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    render() {
        const { formatMessage } = this.props.intl;
        const { showAddEditPanel } = this.props.addEditPanel;
        let slidingPanelProps = { ...this.props };
        if (showAddEditPanel) {
            slidingPanelProps = {
                ...slidingPanelProps,
                ...this.props.addEditPanel,
            };
        }

        return (
            <div className="content-table-container">
                <ImportExportHeader
                    {...this.props}
                    service={service}
                    onToggleModalClick={this.onToggleModalClick}
                    onToggleActiveClick={service.toggleColumnVisibility}
                />
                <DataTable
                    isEditable
                    isCheckbox
                    service={service}
                    messages={messages}
                    {...this.props}
                    footerOptions={this.tableFooterOptions}
                />
                {!showAddEditPanel ? null : (
                    <form onSubmit={(event) => preventBubbleUp(event)}>
                        <SlidingPanel
                            {...slidingPanelProps}
                            close={this.props.closeSidePanel}
                            component={AddEditPanel}
                            navigateTo={{
                                parentNameCode: "101",
                                childNameCode: "132",
                            }}
                        >
                            <Button
                                type="save"
                                forceSubmit
                                onClick={() => this.props.onSubmit()}
                                testId="nutrient-target-value-save-button"
                            />
                            <Button
                                type="cancel"
                                onClick={() => this.props.closeSidePanel()}
                                testId="nutrient-target-value-cancel-button"
                            />
                        </SlidingPanel>
                    </form>
                )}
                <DialogBox
                    className="view-log-dialog-box"
                    isOpen={this.state.isModalOpen}
                    draggable
                    unrestricted
                    onClose={() => this.onToggleModalClick()}
                    title={formatMessage(messages.nutrientTargetValueLogHistory)}
                    testId="nutrient-target-value-log-history-modal"
                >
                    <NutrientTargetValueLog needs={this.props.needs} />
                </DialogBox>
            </div>
        );
    }
}
export const NutrientTargetValue = injectIntl(
    withMasked(withApiResult(withCrud(NutrientTargetValue_, service, actions), actions.importData))
);
